import React, { useState } from 'react';
import api from '../api';
import { useAuth } from '../context/AuthContext';

export default function ChangePassword() {
  const { logout } = useAuth();
  const [form, setForm] = useState({ newPassword:'', confirm:'' });
  const [err,  setErr]  = useState('');
  const [ok,   setOk]   = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async e => {
    e.preventDefault();
    if (form.newPassword.length < 6) { setErr('Password must be at least 6 characters'); return; }
    if (form.newPassword !== form.confirm) { setErr('Passwords do not match'); return; }
    setBusy(true); setErr('');
    try {
      await api.post('/auth/change-password', { new_password: form.newPassword });
      setOk('Password changed! Please sign in again.');
      setTimeout(() => logout(), 2000);
    } catch (ex) {
      setErr(ex.response?.data?.error || 'Failed to change password');
    } finally { setBusy(false); }
  };

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'var(--bg)' }}>
      <div style={{ width:'100%', maxWidth:380, padding:24 }}>
        <div style={{ textAlign:'center', marginBottom:28 }}>
          <div style={{ fontSize:32, marginBottom:12 }}>🔑</div>
          <h2 style={{ fontSize:18, fontWeight:600, marginBottom:6 }}>Set Your Password</h2>
          <p style={{ fontSize:13, color:'var(--text2)' }}>This is your first login. Please set a new password to continue.</p>
        </div>
        <div className="card" style={{ padding:24 }}>
          <form onSubmit={submit}>
            <div className="form-group">
              <label>New Password</label>
              <input type="password" value={form.newPassword} autoFocus
                onChange={e => setForm(f => ({ ...f, newPassword: e.target.value }))}
                placeholder="Minimum 6 characters" />
            </div>
            <div className="form-group">
              <label>Confirm Password</label>
              <input type="password" value={form.confirm}
                onChange={e => setForm(f => ({ ...f, confirm: e.target.value }))}
                placeholder="Repeat your password" />
            </div>
            {err && <div className="err-msg">{err}</div>}
            {ok  && <div className="ok-msg">{ok}</div>}
            <button type="submit" className="btn btn-primary" disabled={busy}
              style={{ width:'100%', justifyContent:'center', marginTop:16, padding:'10px' }}>
              {busy ? 'Saving…' : 'Set Password & Continue'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
